import * as React from "react";
import { forwardRef, useContext } from "react";
import styled, { css } from "styled-components";
import zIndices from "theme/z-indices";
import Icon from "components/common/Icon";
import SortIcon from "components/common/EntityDataTable/SortIcon";
import ResizeHandle from "components/common/EntityDataTable/ResizeHandle";
import { CELL_PADDING } from "components/common/EntityDataTable/Constants";
import { ThInner, LeftCol } from "components/common/EntityDataTable/hooks/useAttributeColumnDefinitions";
import HeaderActionsDropdown from "components/common/EntityDataTable/HeaderActionsDropdown";
import ActiveSliceColContext from "components/common/EntityDataTable/contexts/ActiveSliceColContext";
const CustomDragOverlay = styled.div(
  ({ theme, $minWidth }) => css`
    background-color: ${theme.colors.global.contentBackground};
    z-index: ${zIndices.dropdownMenu};
    padding: ${CELL_PADDING}px;
    width: ${$minWidth}px;
    min-width: fit-content;
    font-weight: bold;
    white-space: nowrap;
    max-width: 300px;
    box-shadow:
      rgb(0 0 0 / 5%) 0 1px 3px 0,
      rgb(0 0 0 / 5%) 0 28px 23px -7px,
      rgb(0 0 0 / 4%) 0 12px 12px -7px;

    border-radius: 3px;
    border: 1px solid ${theme.colors.input.borderFocus};
    display: flex;
    align-items: center;
    line-height: 0;
  `
);
const DragHandle = styled.div(
  ({ $isDragging, theme }) => css`
    display: inline-block;
    cursor: ${$isDragging ? "grabbing" : "grab"};
    margin-right: ${theme.spacings.xxs};
  `
);
const DragIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
const ActiveSliceIcon = styled(Icon)(
  ({ theme }) => css`
    display: inline-flex;
    margin-left: ${theme.spacings.xs};
    color: ${theme.colors.text.secondary};
    cursor: default;
  `
);
const ThGhostInner = ({ column }, ref) => {
  var _a, _b;
  const activeSliceCol = useContext(ActiveSliceColContext);
  const columnMeta = (_a = column.columnDef) == null ? void 0 : _a.meta;
  const columnLabel = (_b = columnMeta == null ? void 0 : columnMeta.label) != null ? _b : column.id;
  const canSlice = columnMeta == null ? void 0 : columnMeta.enableSlicing;
  const canSort = column.getCanSort();
  const isSliceActive = Boolean(canSlice && activeSliceCol === column.id);
  const sortDirection = column.getIsSorted();
  return /* @__PURE__ */ React.createElement(CustomDragOverlay, { ref, $minWidth: column.getSize() }, /* @__PURE__ */ React.createElement(ThInner, null, /* @__PURE__ */ React.createElement(LeftCol, null, /* @__PURE__ */ React.createElement(DragHandle, { $isDragging: true }, /* @__PURE__ */ React.createElement(DragIcon, { name: "drag_indicator" })), /* @__PURE__ */ React.createElement(
    HeaderActionsDropdown,
    {
      label: columnLabel,
      activeSort: sortDirection,
      isSliceActive,
      onChangeSlicing: canSlice ? () => {
      } : void 0,
      sliceColumnId: column.id,
      onSort: canSort ? () => {
      } : void 0
    },
    columnLabel
  ), isSliceActive && /* @__PURE__ */ React.createElement(ActiveSliceIcon, { name: "surgical", title: `Slicing by ${columnLabel}` }), sortDirection && /* @__PURE__ */ React.createElement(SortIcon, { column })), column.getCanResize() && /* @__PURE__ */ React.createElement(ResizeHandle, { colTitle: columnLabel })));
};
const ThDragOverlay = forwardRef(ThGhostInner);
export default ThDragOverlay;
